import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Grid, withStyles } from '@material-ui/core'
import { Info, Share, ShowChart } from '@material-ui/icons'
import NextButton from './NextButton'
import CancelButton from './CancelButton'
import Stepper from './Stepper'
import { stepperGoTo } from 'actions/view'
import { togglePreviewResponseView } from 'actions/signupForm/addOrEdit'
import { FileTable } from 'mdi-material-ui'

const InfoIcon = connect(
	(state) => ({ active: state.view.stepper.form === 0 }),
	null,
)(({ active }) => <Info style={{ color: active ? '#18b940' : '#014c94' }} />)

const FileTableIcon = connect(
  state => ({
    active: state.view.stepper.form === 1,
    formID: state.signupForm.addOrEdit.formID,
    formTypeSelected: state.signupForm.addOrEdit.formTypeSelected,
    internal_type: state.customForm?.addOrEdit?.internal_type,
  }),
  null,
)(({ active, formID, formTypeSelected, internal_type }) => (
  <FileTable
    style={{
      color:
        formID === 'new' && !formTypeSelected
          ? 'gray'
          : active
          ? '#18b940'
          : '#014c94',
    }}
  />
))

const ShareIcon = connect(
	(state) => ({
		formID: state.signupForm.addOrEdit.formID,
		active: state.view.stepper.form === 2,
		internal_type: state.customForm?.addOrEdit?.internal_type,
	}),
	null,
)(({ formID, active, internal_type }) => {
	return (
		<Share
			style={{
				color: formID === 'new' ? 'gray' : active ? '#18b940' : '#014c94',
			}}
		/>
	)
})

const ShowChartIcon = connect(
	(state) => ({
		formID: state.signupForm.addOrEdit.formID,
		active: state.view.stepper.form === 3,
	}),
	null,
)(({ formID, active }) => {
	return (
		<ShowChart
			style={{
				color: formID === 'new' ? 'gray' : active ? '#18b940' : '#014c94',
			}}
		/>
	)
})

const steps = [
	{
		label: 'Form',
		Icon: <InfoIcon />,
	},
	{ label: 'Build', Icon: <FileTableIcon /> },
	{
		label: 'Share',
		Icon: <ShareIcon />,
	},
	{
		label: 'Analyze',
		Icon: <ShowChartIcon />,
	},
]

class StepperContainer extends Component {
	componentWillUnmount() {
		this.props.stepperGoTo(0, 'form')
	}

	render() {
		return (
			<Grid
				container
				justify="space-between"
				className={this.props.classes.buttonsStyle}
			>
				<Grid item>
					<CancelButton />
				</Grid>
				<Stepper formID={this.props.formID} steps={steps} />
				<Grid item>
					<NextButton
						CustomCreateButton={this.props.CustomCreateButton}
						stepsLength={steps.length}
					/>
				</Grid>
			</Grid>
		)
	}
}

const styles = (theme) => ({
	buttonsStyle: {
		[theme.breakpoints.down('xs')]: {
			width: '100%',
			left: 0,
			top: 56,
		},
		width: 'calc(100% - 80px)',
		position: 'fixed',
		left: '80px',
		// bottom: '0px',
		top: 64,
		padding: '7.5px 12px',
		background: 'white',
		boxShadow: '0px 5px 5px #00000040',
		zIndex: 3,
		overflowY: 'hidden',
	},
})

export default connect(
	(state) => ({ formID: state.signupForm.addOrEdit.formID }),
	(dispatch) =>
		bindActionCreators({ stepperGoTo, togglePreviewResponseView }, dispatch),
)(withStyles(styles)(StepperContainer))
